import { render } from "./DepartamentoForm.vue?vue&type=template&id=0875fcd7&scoped=true"
import script from "./DepartamentoForm.vue?vue&type=script&lang=js"
export * from "./DepartamentoForm.vue?vue&type=script&lang=js"

import "./DepartamentoForm.vue?vue&type=style&index=0&id=0875fcd7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0875fcd7"]])

export default __exports__